import { Text } from "components/commons";
import styles from "../cash-noncash.module.scss";
import { formatAmount, formatVolume } from "utils";
import PumpMethodEnum from "enums/pump-method";

export const nonSaleTransactionMapper = ({ val, initialState }) => {
  const {
    pumpNumber,
    name,
    refNumber,
    quantity,
    totalAmount,
    refName,
    plateNumber,
    type,
    remarks,
    receiptNumber,
    from,
  } = val;

  const isDryStock = !["Diesel", "Gas 91", "Gas 95", "Gas 97"].includes(name);

  const isNegative = (value) => {
    const number = parseFloat(value);
    return !isNaN(number) && number < 0;
  };

  function validate(value) {
    const number = parseFloat(value);
    return Math.abs(number);
  }

  return {
    pump: (
      <>
        <Text className={styles.content}>{isDryStock ? "--" : (pumpNumber ?? "1")}</Text>
      </>
    ),
    product: (
      <>
        <Text className={styles.content}>{name || "--"}</Text>
      </>
    ),
    transactionType: (
      <>
        <Text className={styles.content}>{PumpMethodEnum[from] || "--"}</Text>
      </>
    ),
    referenceNo: (
      <>
        <Text className={styles.content}>{refNumber || "--"}</Text>
      </>
    ),
    quantity: (
      <>
        <Text className={styles.content}>
          {type === "fuel" ? formatVolume(validate(quantity) ?? 0) : validate(quantity)}
        </Text>
      </>
    ),
    amount: (
      <>
        <Text
          style={{ width: "60px" }}
          className={isNegative(totalAmount) ? styles.negative : styles.content}
        >
          {formatAmount(totalAmount)}
        </Text>
      </>
    ),
    transactionId: (
      <>
        <Text className={styles.content}>{receiptNumber ?? ""}</Text>
      </>
    ),
    refName: (
      <>
        <Text className={styles.content}>{refName || "--"}</Text>
        <Text className={styles.content}>{plateNumber || "--"}</Text>
      </>
    ),
    remarks: (
      <>
        <Text className={styles.content}>{remarks || "--"}</Text>
      </>
    ),
  };
};
